export default __webpack_public_path__ + "static/banner-how-to-plan-for-the-future-when-youre-living-in-the-now-3ab8fc1151c95d2d5cc026141b208cdd.jpg";